import { createContext, useContext, useEffect, useState } from "react";
import { useCommunityInstallationsAPI } from "service/communities/CommunityInstallationsAPIService";


export const CommunityInstallationContext = createContext();

export const CommunityInstallationProvider = ({ id, children, ...props }) => {

    const service = useCommunityInstallationsAPI();

    const [installation, setInstallation] = useState(null);
    const [isGetting, setIsGetting] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    
    const get = (id) => {
        if(isGetting) return;

        setIsGetting(true);
        service.get(id).then((response) => {
            setInstallation(response.data);
        }).catch((error) => {
            console.error(error);
        }).finally(() => {
            setIsGetting(false);
        });
    }

    const update = (data) => {
        if(isUpdating) return Promise.reject(new Error("Update already in progress"));

        setIsUpdating(true);
        return service.update(id, data).then((response) => {
            setInstallation(response.data);
            return response.data;
        }).catch((error) => {
            console.error(error);
            throw error; // Re-throw the error so consumers can handle it
        }).finally(() => {
            setIsUpdating(false);
        });
    };

    const remove = async () => {
        setIsUpdating(true);
        try {
            const response = await service.remove(id);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setIsUpdating(false);
        }
    };

    useEffect(() => {
        get(id);
    }, [id]);

    const returnObject = {
        isGetting,
        isUpdating,
        installation,
        update,
        get,
        remove
    }

    return (
        <CommunityInstallationContext.Provider value={returnObject}>
            {children}
        </CommunityInstallationContext.Provider>
    );
}

export const useCommunityInstallationContext = () => {
    const context = useContext(CommunityInstallationContext);
    if (!context) {
        throw new Error("useCommunityInstallationContext must be used within a CommunityInstallationProvider");
    }
    return context;
}